import axios from 'axios';

import config from '../enviroment/config.json';
import Cookies from '../util/cookies';


export default function(state = {}) {
  var token = "";
  if (!state?.user?.token) {
    token = Cookies.get('token') || "";
  }
  else {
    token = state.user.token;
  }
  return axios.create({
    baseURL: config.api[config.current_enviroment],
    headers: {'Authorization': "Bearer "+(token || "")},
  })
}